import React from 'react';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faDownload,
  faRefresh,
} from '@fortawesome/free-solid-svg-icons';
import {
  HeaderRow,
  HeaderLeft,
  HeaderRight,
  PageTitle,
  PageSubtitle,
} from './Styles';
import { PAGE_TITLE, PAGE_SUBTITLE, PAGE_SUBTITLE_DATE, BUTTON_LABELS } from './constants';
import type { HeaderSectionProps } from './types';

const formatDisplayDate = (d: string): string => {
  const date = new Date(d);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

const HeaderSection: React.FC<HeaderSectionProps> = ({
  startDate,
  endDate,
  onBack,
  onExport,
  onRefresh,
  exportLoading,
  refreshLoading,
}) => (
  <HeaderRow>
    <HeaderLeft>
      <Button
        type="text"
        icon={<FontAwesomeIcon icon={faArrowLeft} />}
        onClick={onBack}
        aria-label="Go back"
      />
      <div>
        <PageTitle>{PAGE_TITLE}</PageTitle>
        <PageSubtitle>
          {PAGE_SUBTITLE} • {PAGE_SUBTITLE_DATE(formatDisplayDate(startDate), formatDisplayDate(endDate))}
        </PageSubtitle>
      </div>
    </HeaderLeft>
    <HeaderRight>
      <Button
        icon={<FontAwesomeIcon icon={faDownload} />}
        onClick={onExport}
        loading={exportLoading}
      >
        {BUTTON_LABELS.EXPORT_CSV}
      </Button>
      <Button
        type="primary"
        icon={<FontAwesomeIcon icon={faRefresh} />}
        onClick={onRefresh}
        loading={refreshLoading}
      >
        {BUTTON_LABELS.REFRESH}
      </Button>
    </HeaderRight>
  </HeaderRow>
);

export default React.memo(HeaderSection);
